
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/bundles-list",
      function () {
        return require("private-next-pages/product/bundles-list/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/bundles-list"])
      });
    }
  